"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
        }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];return o(n || r);
        }, p, p.exports, r, e, n, t);
      }return n[i].exports;
    }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }return o;
  }return r;
})()({ 1: [function (require, module, exports) {
    'use strict';

    function getScrollTop() {
      return window.pageYOffset || document.body.scrollTop;
    }
    getScrollTop.getScrollTop = getScrollTop.top = getScrollTop;
    getScrollTop.getScrollLeft = getScrollTop.left = function () {
      return window.pageXOffset || document.body.scrollLeft;
    };
    module.exports = getScrollTop;
  }, {}], 2: [function (require, module, exports) {
    /*! npm.im/one-event */
    'use strict';

    function once(target, type, listener, useCapture) {
      target.addEventListener(type, listener, useCapture);
      target.addEventListener(type, function selfRemoving() {
        target.removeEventListener(type, listener, useCapture);
        target.removeEventListener(type, selfRemoving, useCapture);
      }, useCapture);
    }

    once.promise = function (target, type, useCapture) {
      return new Promise(function (resolve) {
        return once(target, type, resolve, useCapture);
      });
    };

    module.exports = once;
  }, {}], 3: [function (require, module, exports) {
    /*! npm.im/scroll-restoration-polyfill */
    'use strict';

    function _interopDefault(ex) {
      return ex && (typeof ex === "undefined" ? "undefined" : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
    }

    var once = _interopDefault(require('one-event'));
    var getScroll = require('get-scroll');

    var state = 'auto';

    function waitForScroll() {
      once(window, 'scroll', scrollTo.bind(window, getScroll.getScrollLeft(), getScroll.getScrollTop()));
    }

    if (!('scrollRestoration' in history)) {
      Object.defineProperty(history, 'scrollRestoration', {
        enumerable: true,
        get: function get() {
          return state;
        },
        set: function set(requestedState) {
          if (requestedState === state) {
            return;
          }
          if (requestedState === 'auto') {
            window.removeEventListener('popstate', waitForScroll);
            state = requestedState;
          } else if (requestedState === 'manual') {
            window.addEventListener('popstate', waitForScroll);
            state = requestedState;
          }
        }
      });
    }
  }, { "get-scroll": 1, "one-event": 2 }], 4: [function (require, module, exports) {
    /**
      shave - Shave is a javascript plugin that truncates multi-line text within a html element based on set max height
      @version v2.5.2
      @link https://github.com/dollarshaveclub/shave#readme
      @author Jeff Wainwright <yowainwright@gmail.com> (jeffry.in)
      @license MIT
    **/
    (function (global, factory) {
      (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.shave = factory();
    })(this, function () {
      'use strict';

      function shave(target, maxHeight) {
        var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!maxHeight) throw Error('maxHeight is required');
        var els = typeof target === 'string' ? document.querySelectorAll(target) : target;
        if (!els) return;
        var character = opts.character || '…';
        var classname = opts.classname || 'js-shave';
        var spaces = typeof opts.spaces === 'boolean' ? opts.spaces : true;
        var charHtml = "<span class=\"js-shave-char\">".concat(character, "</span>");
        if (!('length' in els)) els = [els];

        for (var i = 0; i < els.length; i += 1) {
          var el = els[i];
          var styles = el.style;
          var span = el.querySelector(".".concat(classname));
          var textProp = el.textContent === undefined ? 'innerText' : 'textContent'; // If element text has already been shaved

          if (span) {
            // Remove the ellipsis to recapture the original text
            el.removeChild(el.querySelector('.js-shave-char'));
            el[textProp] = el[textProp]; // eslint-disable-line
            // nuke span, recombine text
          }

          var fullText = el[textProp];
          var words = spaces ? fullText.split(' ') : fullText; // If 0 or 1 words, we're done

          if (words.length < 2) continue; // Temporarily remove any CSS height for text height calculation

          var heightStyle = styles.height;
          styles.height = 'auto';
          var maxHeightStyle = styles.maxHeight;
          styles.maxHeight = 'none'; // If already short enough, we're done

          if (el.offsetHeight <= maxHeight) {
            styles.height = heightStyle;
            styles.maxHeight = maxHeightStyle;
            continue;
          } // Binary search for number of words which can fit in allotted height


          var max = words.length - 1;
          var min = 0;
          var pivot = void 0;

          while (min < max) {
            pivot = min + max + 1 >> 1; // eslint-disable-line no-bitwise

            el[textProp] = spaces ? words.slice(0, pivot).join(' ') : words.slice(0, pivot);
            el.insertAdjacentHTML('beforeend', charHtml);
            if (el.offsetHeight > maxHeight) max = spaces ? pivot - 1 : pivot - 2;else min = pivot;
          }

          el[textProp] = spaces ? words.slice(0, max).join(' ') : words.slice(0, max);
          el.insertAdjacentHTML('beforeend', charHtml);
          var diff = spaces ? " ".concat(words.slice(max).join(' ')) : words.slice(max);
          el.insertAdjacentHTML('beforeend', "<span class=\"".concat(classname, "\" style=\"display:none;\">").concat(diff, "</span>"));
          styles.height = heightStyle;
          styles.maxHeight = maxHeightStyle;
        }
      }

      return shave;
    });
  }, {}], 5: [function (require, module, exports) {
    'use strict';

    $('body').on('htmlpress-ready', function () {
      $('#site-root [data-js]').each(function () {
        eval($(this).data('js'));
      });
    });
  }, {}], 6: [function (require, module, exports) {
    'use strict';

    window.isLoadingDatepickers = false;

    $('body').on('htmlpress-ready', function () {
      window.isLoadingDatepickers = true;

      $('#site-root').find('[data-datepicker], [data-is-datepicker]').each(function () {
        var settings = {};

        [].filter.call(this.attributes, function (attr) {
          return (/^data-datepicker/.test(attr.name)
          );
        }).forEach(function (attr) {
          var name = attr.name.replace(/^data-datepicker-?/, '').replace(/-[a-z]/g, function (s) {
            return s.charAt(1).toUpperCase();
          }).trim();

          if (!name) {
            return;
          }

          var value = attr.value;

          if (typeof value === 'string') {
            value = value.trim();

            try {
              value = eval(value);
            } catch (e) {
              value = attr.value.trim();
            }
          }

          settings[name] = value;
        });

        $('#site-root').find('[data-value]:not([data-value=""])').each(function () {
          $(this).val($(this).data('value'));
        });

        settings.field = this;

        console.log('Initializing Pikaday with settings', settings);

        new Pikaday(settings);
      });

      window.isLoadingDatepickers = false;
    });
  }, {}], 7: [function (require, module, exports) {
    'use strict';

    var lineClamp = require('shave');

    function clampLines() {
      var clampedLines = $('#site-root [data-line-clamp]').each(function () {
        var lineHeight = ($(this).css('line-height') || $(this).css('font-size')).toString().replace(/[^0-9\.]+/g, '') * 1;
        var maxLines = ($(this).data('line-clamp') || '').toString().replace(/[^0-9\.]+/g, '') * 1,
            maxHeight;

        if (!maxLines || maxLines < 1) {
          $(this).addClass('is-line-clamping');

          maxLines = Math.max(Math.floor(($(this).height() || lineHeight) / lineHeight), 1);

          $(this).removeClass('is-line-clamping');
        }

        maxHeight = maxLines * lineHeight + 1;

        // console.log(this, lineHeight, maxLines, maxHeight);

        lineClamp(this, maxHeight);

        $(this).addClass('is-line-clamped');
      });
    };

    (function () {
      var timeout;

      window.addEventListener('resize', function (event) {
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }

        timeout = window.requestAnimationFrame(function () {
          clampLines();
        });
      }, false);
    })();

    $('body').on('htmlpress-ready', function () {
      clampLines();
    });
  }, { "shave": 4 }], 8: [function (require, module, exports) {
    'use strict';

    $('body').on('htmlpress-ready', function () {
      $('input[type="radio"]').each(function () {
        $(this).data('checked-state', $(this).is(':checked') ? 'checked' : 'unchecked');
      }).on('click', function () {
        if ($(this).data('checked-state') !== 'checked') {
          return;
        }

        $(this).data('checked-state', 'unchecked');
        $(this).prop('checked', false).trigger('change');
      });
    });
  }, {}], 9: [function (require, module, exports) {
    'use strict';

    window.$ = window.jQuery;

    function loadHandler() {
      if (htmlpress.loadCallbacks <= 0) {
        return;
      }

      if (--htmlpress.loadCallbacks < 1) {
        htmlpress.loadedCallback();
      }
    }

    var htmlpress = window.htmlpress = {
      options: {
        cacheLimit: 10,
        loadTimeout: 2500
      },
      loadedTimeout: null,
      loadedCallback: function loadedCallback() {
        clearTimeout(htmlpress.loadedTimeout);

        if (htmlpress.loadCallbacks > 0) {
          console.log('Load wait exceeded, loading now');
        }

        htmlpress.loadCallbacks = 0;

        $('#prev-site-root').html('');

        $('body').trigger('htmlpress-loaded');
      },
      loadCallbacks: 0,
      getLoadCallback: function getLoadCallback() {
        htmlpress.loadCallbacks++;
        return loadHandler;
      }
    };

    window.FontAwesomeConfig = {};

    // require('@fortawesome/fontawesome');
    // require('@fortawesome/fontawesome-pro-solid');
    // require('@fortawesome/fontawesome-pro-regular');
    // require('@fortawesome/fontawesome-pro-light');
    // require('@fortawesome/fontawesome-free-brands');

    // require('./wp-functions.js');

    (function ($) {
      var isIE = /*@cc_on!@*/false || !!document.documentMode; // IE 6-11

      $('body').trigger('htmlpress-init');

      if ($('body.admin-bar').length < 1 && !isIE) {
        require('./smooth-state.js');
      }

      $(function () {
        $('body').on('change', '[data-submit-on="change"]', function () {
          if (window.isLoadingDatepickers) {
            return;
          }

          $(this).submit();
        });
      });

      require('./webflow-nav-scrollblock.js');
      require('./radio-uncheck.js');

      require('./toggle.js');
      require('./toggle-links.js');
      require('./select2.js');
      require('./sticky.js');
      require('./slick.js');
      require('./line-clamp.js');
      require('./data-js.js');
      require('./datepicker.js');
      require('./simplebar-arrows.js');
      require('./slot-debug.js');

      $('body').on('htmlpress-ready', function () {
        htmlpress.loadedTimeout = setTimeout(htmlpress.loadedCallback, htmlpress.options.loadTimeout);

        $('#site-root [data-masonry]').each(function () {
          $(this).attr('data-masonry-tmp', $(this).attr('data-masonry'));
          $(this).attr('data-masonry', null);
        });

        // Images loaded is zero because we're going to process a new set of images.
        var imagesLoaded = 0;
        // Total images is still the total number of <img> elements on the page.
        var totalImages = $('#site-root img').length;

        var imageLoadedTimeout = null;

        // Step through each image in the DOM, clone it, attach an onload event
        // listener, then set its source to the source of the original image. When
        // that new image has loaded, fire the imageLoaded() callback.
        $('#site-root img').each(function (idx, img) {
          $('<img>').on('load', imageLoaded).attr('src', $(img).attr('src'));
        });

        // Do exactly as we had before -- increment the loaded count and if all are
        // loaded, call the allImagesLoaded() function.
        function imageLoaded() {
          imagesLoaded++;
          if (imagesLoaded == totalImages) {
            allImagesLoaded();
          }
        }

        var imagesLoadedHandler = htmlpress.getLoadCallback();

        function allImagesLoaded() {
          console.log('Images loaded');

          imagesLoadedHandler();

          clearTimeout(imageLoadedTimeout);

          setTimeout(function () {
            $('[data-masonry-tmp], [data-masonry]').each(function () {
              new Masonry(this, $(this).data('masonry-tmp') || $(this).data('masonry'));

              $(this).attr('data-masonry', null).attr('data-masonry-tmp', null);
              $(this).addClass('masonry-loaded');
            });
          }, 50);
        }

        var imageLoadedTimeout = setTimeout(allImagesLoaded, 1500);
      });

      $('body').trigger('htmlpress-ready');
    })(jQuery);
  }, { "./data-js.js": 5, "./datepicker.js": 6, "./line-clamp.js": 7, "./radio-uncheck.js": 8, "./select2.js": 10, "./simplebar-arrows.js": 11, "./slick.js": 13, "./slot-debug.js": 14, "./smooth-state.js": 15, "./sticky.js": 16, "./toggle-links.js": 17, "./toggle.js": 18, "./webflow-nav-scrollblock.js": 19 }], 10: [function (require, module, exports) {
    'use strict';

    $('body').on('htmlpress-ready', function () {
      $('#site-root').find('select.is-select2, .is-select2:not(select) select').select2();
    });
  }, {}], 11: [function (require, module, exports) {
    'use strict';

    $('body').on('htmlpress-ready', function () {
      $('#site-root [data-simplebar-arrow]').each(function () {
        var scrollDirection = $(this).data('simplebar-arrow'),
            scrollFactor = 1,
            self = this;

        if (scrollDirection === 'up' || scrollDirection === 'right') {
          scrollFactor = -1;
        }

        $(self).on('click', function (e) {
          e.preventDefault();

          var $scrollArea = $(self).parent().find('.simplebar-wrapper').find('.simplebar-content').first(),
              scrollAmount = Math.min(250, $scrollArea.height() * 0.25) * scrollFactor;

          console.log(self, $scrollArea.scrollTop() + scrollFactor, scrollFactor, $scrollArea);

          $scrollArea.stop(true, false).animate({ scrollTop: $scrollArea.scrollTop() + scrollAmount });
        });

        var toggleVisible = function toggleVisible() {
          var $scrollBar = $(self).parent().find('.simplebar-vertical');

          $(self).animate({ opacity: $scrollBar.css('visibility') == 'hidden' ? 0 : 1 }, 250);

          // $scrollBar.one('DOMAttrModified', function () {
          //   toggleVisible();
          // });
        };

        var interval = setInterval(function () {
          toggleVisible();
        }, 750);

        $('body').one('htmlpress-ready', function () {
          clearInterval(interval);
        });
      });
    });
  }, {}], 12: [function (require, module, exports) {
    'use strict';

    module.exports = function (slider, settings, total_slides) {
      var deltaTimeout = null,
          deltaY = 0,
          shouldScrollPastSlider = false;

      function scrollSlider(e, currentDeltaY) {

        deltaY += currentDeltaY;

        console.log('current Y:', currentDeltaY, ' y buffer', deltaY);

        if (settings.scrollThreshold) {
          clearTimeout(deltaTimeout);

          deltaTimeout = setTimeout(function () {
            console.log('clearing y buffer');
            deltaY = 0;
          }, 75);

          var offset = $(slider).offset();

          if (offset && $(window).scrollTop() - offset.top >= 10) {
            return;
          }

          if (Math.abs(deltaY) < settings.scrollThreshold) {
            if (!shouldScrollPastSlider) {
              e.preventDefault();
            }

            return;
          }
        }

        var slideTo = function slideTo(s) {
          var current_slide = $(slider).slick('slickCurrentSlide');

          if (s === 'next') {
            if (current_slide < total_slides) {
              shouldScrollPastSlider = false;
              $(slider).slick('slickNext');
              e.preventDefault();
            } else {
              shouldScrollPastSlider = true;
            }
          } else {
            if (current_slide > 0) {
              shouldScrollPastSlider = false;
              $(slider).slick('slickPrev');
              e.preventDefault();
            } else {
              shouldScrollPastSlider = true;
            }
          }
        };

        if (settings.vertical) {
          if (deltaY >= 0) {
            slideTo('next');
          } else {
            slideTo('prev');
          }
        } else {
          if (deltaY < 0) {
            slideTo('next');
          } else {
            slideTo('prev');
          }
        }

        setTimeout(function () {
          deltaY = 0;
        }, 50);

        setTimeout(function () {
          deltaY = 0;
        }, 250);

        setTimeout(function () {
          deltaY = 0;
        }, 500);

        deltaY = 0;
      }

      $(slider).parent().on('wheel', '.slick-initialized.slick-vertical', function (e) {
        scrollSlider(e, e.originalEvent.deltaY);
      });

      var start = { x: 0, y: 0 };

      $(slider).parent().on('touchstart', '.slick-initialized.slick-vertical', function (event) {
        start.x = event.touches[0].pageX;
        start.y = event.touches[0].pageY;
      });

      $(slider).parent().on('touchmove', '.slick-initialized.slick-vertical', function (event) {
        var offset = {};

        offset.x = start.x - event.touches[0].pageX;
        offset.y = start.y - event.touches[0].pageY;

        scrollSlider(event, offset.y);

        return offset;
      });
    };
  }, {}], 13: [function (require, module, exports) {
    'use strict';

    var slickVerticalScroll = require('./slick-vertical-scroll.js');

    $('body').on('htmlpress-ready', function () {
      $('#site-root').find('.is-slick, [data-is-slick], [data-slick]').each(function () {
        var settings = {};

        try {
          if ($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
          }

          $(this).find('.slick-initialized').slick('unslick');
        } catch (e) {
          console.log(e);
        }

        [].filter.call(this.attributes, function (attr) {
          return (/^data-slick/.test(attr.name)
          );
        }).forEach(function (attr) {
          var name = attr.name.replace(/^data-slick-?/, '').replace(/-[a-z]/g, function (s) {
            return s.charAt(1).toUpperCase();
          }).trim();

          if (!name) {
            return;
          }

          var value = attr.value;

          if (typeof value === 'string') {
            value = value.trim();

            try {
              value = eval(value);
            } catch (e) {
              value = attr.value.trim();
            }
          }

          settings[name] = value;
        });

        if (!settings.hasOwnProperty('nextArrow')) {
          settings.nextArrow = $(this).find('.slick-next, [data-slick-arrow="next"]');
        }

        if (!settings.hasOwnProperty('prevArrow')) {
          settings.prevArrow = $(this).find('.slick-prev, [data-slick-arrow="prev"]');
        }

        var slide_container = $(this).find('[data-slick-slides]')[0];

        if (!slide_container) {
          slide_container = this;
        }

        var slides = $(slide_container).children().not('script, :empty');

        var total_slides = slides.length - 1;

        $(slide_container).children(':not(div), .htmlpress-slot-debug').remove();

        try {
          $(slide_container).slick(settings);
        } catch (e) {
          console.log(e.message);
          console.log(e.stack);
        }

        console.log('Init slick with settings', settings, ' on ', slide_container);

        if (settings.scrollMove) {
          slickVerticalScroll(slide_container, settings, total_slides);
        }
      });
    });
  }, { "./slick-vertical-scroll.js": 12 }], 14: [function (require, module, exports) {
    'use strict';

    $('body').on('htmlpress-ready', function () {
      $('#site-root').find('[name="htmlpress-slot-debug-radio"]').each(function () {});

      $('.htmlpress-slot-nav-link').eq(1).trigger('click');
    });

    $('body').on('click', '.htmlpress-slot-nav-link', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var radios = [];

      $('[name="htmlpress-slot-debug-radio"]').each(function () {
        if ($(this).next().is(':visible')) {
          radios.push(this);
        }
      });

      var checkedIndex = -1;

      radios.some(function (r, i) {
        if ($(r).is(':checked')) {
          checkedIndex = i;
          return true;
        }
      });

      if ($(this).is(':first-child')) {
        checkedIndex--;
      } else {
        checkedIndex++;
      }

      if (checkedIndex >= radios.length - 1) {
        checkedIndex = 0;
      }

      if (checkedIndex < 0) {
        checkedIndex = radios.length - 1;
      }

      var $radio = $(radios[checkedIndex]);

      if ($radio.length < 1) {
        return;
      }

      $radio.prop('checked', true);

      $('html, body').finish().animate({
        scrollTop: Math.max(0, $(this).parents('.htmlpress-slot-debug').offset().top - 250)
      });
    });

    $('body').on('click', '[data-slot-value]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      alert($(this).data('slot-value'));
    });
  }, {}], 15: [function (require, module, exports) {
    'use strict';

    require('scroll-restoration-polyfill');

    history.scrollRestoration = 'manual';

    var htmlpress = window.htmlpress,
        $siteRoot = $('#site-root'),
        appendedScripts = false,
        isPopState = false,
        scrollHistory = window.scrollHistory = {
      lastObjectID: $('body').attr('data-object-id'),
      currentTarget: null
    },
        xhrObjects = window.xhrObjects = {},
        lastRequestURL = window.location.href,
        slowRequestTimeout = null,
        isRequesting = true;

    function clearXHRObject(htmlOrXhr, status, errorOrXhr) {
      var xhr = htmlOrXhr.statusCode ? htmlOrXhr : errorOrXhr;

      delete xhrObjects[xhr.requestURL];
    }

    $(document).ajaxSend(function (e, jqXHR, options) {
      // var xhr = options.xhr();
      var xhr = jqXHR;

      if (!xhr.requestURL) {
        xhr.requestURL = options.url;
      }

      xhrObjects[options.url] = xhr;

      jqXHR.always(clearXHRObject);
    });

    function logScrollTopHistory() {
      scrollHistory[scrollHistory.lastObjectID] = $(window).scrollTop();
    }

    function hideBodyOnSlowRequest() {
      // $siteRoot.css('opacity', 0);
      isRequesting = false;
      $(document.documentElement).addClass('load-wait-exceeded');
    }

    function resetTimeoutStates() {
      clearTimeout(slowRequestTimeout);
      $(document.documentElement).removeClass('load-wait-exceeded');
      // $siteRoot.css('opacity', 1);
    }

    function isLatestRequest() {
      if (isPopState) {
        return true;
      }

      if (lastRequestURL) {
        if ($siteRoot.data('smoothState').href != lastRequestURL) {
          return false;
        }
      }

      return true;
    }

    // $('body').one('htmlpress-loaded', function () {
    $siteRoot.smoothState({
      debug: true,
      // debug: true  -  required to stop SmoothState forcing
      //                 window.location on ajax abort/fail
      loadingClass: 'is-loading',
      anchors: 'a',
      forms: 'form:not([id^="gform"])',
      prefetch: true,
      cacheLength: htmlpress.options.cacheLimit,
      scroll: false,
      // alterRequest: function (request) {
      //   if (!isPopState && isRequesting && lastRequestURL && window.location.href !== lastRequestURL) {
      //     request.url = lastRequestURL;
      //   }

      //   return request;
      // },
      onBefore: function onBefore($currentTarget, $container) {
        var lastXHR = xhrObjects[lastRequestURL];

        if (lastXHR && lastXHR.abort) {
          console.log('SmoothState: cancelling previous request for ' + lastRequestURL);

          try {
            // lastXHR.onreadystatechange = null;
            lastXHR.abort();

            var cache = $siteRoot.data('smoothState').cache;

            if (lastXHR.requestURL && cache[lastXHR.requestURL]) {
              delete cache[lastXHR.requestURL];
            }
          } catch (e) {
            console.log(e);
          }
        }

        var request = {};

        if ($currentTarget.is('form')) {
          request = {
            url: $currentTarget.prop('action'),
            data: $currentTarget.serialize(),
            type: $currentTarget.prop('method')
          };

          if (request.type.toLowerCase() === 'get') {
            request.url = request.url + '?' + request.data;
          }
        } else {
          request = $.smoothStateUtility.translate($currentTarget.prop('href'));
        }

        if (request && request.url && (request.type.toLowerCase() === 'post' || request.url !== window.location.href)) {
          lastRequestURL = request.url;
          // console.log('SmoothState: ' + request.url + ' != ' + lastRequestURL);
        }

        scrollHistory.currentTarget = $currentTarget;

        $('#prev-site-root').html('');

        clearTimeout(slowRequestTimeout);
        slowRequestTimeout = setTimeout(hideBodyOnSlowRequest, htmlpress.options.loadTimeout);

        isRequesting = true;
      },
      onReady: {
        duration: 5,
        render: function render($container, $newContent) {
          isRequesting = false;

          if (!isLatestRequest()) {
            resetTimeoutStates();
            console.log('SmoothState: not rendering old request: ' + $siteRoot.data('smoothState').href + ', latest request: ' + lastRequestURL);
            return;
          }

          logScrollTopHistory();

          if (!appendedScripts) {
            if ($('head script[src*="gravityforms"]').length < 1) {
              try {
                $('head').append("<script type='text/javascript' src='/wp-content/plugins/gravityforms/js/jquery.json.min.js?ver=2.2.6'></script>" + "<script type='text/javascript' src='/wp-content/plugins/gravityforms/js/gravityforms.min.js?ver=2.2.6'></script>" + "<script type='text/javascript' src='/wp-content/plugins/gravity-forms-placeholders/gf.placeholders.js?ver=1.0'></script>");
              } catch (e) {
                console.log(e);
              }
            }

            appendedScripts = true;
          }

          var $prevRoot = $('#prev-site-root');

          if ($prevRoot.length < 1) {
            var $prevRoot = $('<div id="prev-site-root"></div>');

            $container.before($prevRoot);
          }

          $prevRoot.attr('data-url', window.location.href);
          $siteRoot.attr('data-url', $siteRoot.data('smoothState').href);

          try {
            $container.children().appendTo($prevRoot);
            $container.html($newContent);
          } catch (e) {
            console.log(e);
          }

          var stateHandler = $(scrollHistory.currentTarget).data('state-handler');

          if (typeof stateHandler === 'function') {
            console.log('Calling custom stateHandler from', scrollHistory.currentTarget);
            stateHandler($container, $newContent);
            return;
          }
        }
      },
      onAfter: function onAfter($container, $newContent) {
        resetTimeoutStates();

        if (!isLatestRequest()) {
          console.log('SmoothState: not processing old request ' + $siteRoot.data('smoothState').href);
          return;
        }

        scrollHistory.currentTarget = null;

        var $templateScriptsAjax = $siteRoot.find('.htmlpress-template-scripts-ajax');

        $templateScriptsAjax.html('');

        var smoothState = $siteRoot.data('smoothState');

        var $newDocument = smoothState.cache[smoothState.href];

        if ($newDocument && $newDocument.html) {
          $newDocument = $newDocument.html;
        }

        if (!$newDocument || !$newDocument.length) {
          $newDocument = $newContent;
        }

        $newDocument = $newDocument.parents().last();

        $siteRoot.append($newDocument.find('> style[id^="kt-blocks"], head style[id^="kt-blocks"]').toArray().map(function (node) {
          return node.outerHTML;
        }).join('\n'));

        $('head style[id^="kt-blocks"]').remove();

        if (window.Webflow) {
          if (typeof window.Webflow.destroy === 'function') {
            window.Webflow.destroy();
          }

          window._Webflow = window.Webflow;
          window.Webflow = undefined;
        }

        $('body').trigger('htmlpress-ready');

        if ($.fn.matchHeight) {
          $('[data-mh]').matchHeight();
          $.fn.matchHeight._update();
        }

        setTimeout(function () {
          if ($.fn.matchHeight) {
            $('[data-mh]').matchHeight();
            $.fn.matchHeight._update();
          }
        }, 10);

        $('body').on('htmlpress-loaded', function () {
          try {
            var $templateScripts = $newDocument.find('.htmlpress-template-scripts');

            if ($templateScripts.length < 1) {
              $templateScripts = $newContent.parents().last().find('.htmlpress-template-scripts');
            }

            $templateScriptsAjax.append($templateScripts.html());
          } catch (e) {
            console.log(e);
          }

          setTimeout(function () {
            isPopState = false;
          }, 10);
        });

        setTimeout(function () {
          if (document.dispatchEvent && window.CustomEvent) {
            // Force webflow animation
            document.dispatchEvent(new window.CustomEvent('IX2_PREVIEW_LOAD'));
          }
        }, 350);

        setTimeout(function () {
          if (document.dispatchEvent && window.CustomEvent) {
            // Force webflow animation
            document.dispatchEvent(new window.CustomEvent('IX2_PREVIEW_LOAD'));
          }
        }, 750);
      }
    });

    setTimeout(function () {
      var smoothStateHandler = window.onpopstate;

      window.onpopstate = function (e) {
        isPopState = true;
        clearTimeout(slowRequestTimeout);
        slowRequestTimeout = setTimeout(hideBodyOnSlowRequest, htmlpress.options.loadTimeout);

        logScrollTopHistory();

        try {
          smoothStateHandler(e);
        } catch (e) {
          resetTimeoutStates();
          console.log(e.message + '\n' + e.stack);
          window.location = window.location.href;
        }
      };
    }, 10);

    // });

    var prevContent = null;

    function sanitizeElementText(string) {
      return string.trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    function getContentElements($root) {
      var elements = [];

      $($root).find('.htmlpress-content-start').nextUntil('.htmlpress-content-end').each(function () {
        var node = this;

        while ($(node).children().length === 1) {
          node = $(node).children().first();
        }

        $(node).children().each(function () {
          elements.push(this);
        });
      });

      return $(elements);
    }

    function findNewContent() {
      var prevContent = getContentElements($('#prev-site-root')).map(function () {
        return sanitizeElementText($(this).text());
      }).toArray();

      var currContent = getContentElements($siteRoot);
      var currContentText = currContent.map(function () {
        return sanitizeElementText($(this).text());
      }).toArray();

      var length = Math.min(prevContent.length, currContentText.length);
      var found = null;

      if (length > 0) {
        for (var i = 0; i < length; i++) {
          if (prevContent[i] !== currContentText[i]) {
            found = currContent[i];
            break;
          }
        }
      } else {
        found = document.body;
      }

      return $(found);
    }

    function doScroll(scrollTo, animate) {
      if (isPopState) {
        scrollTo = scrollHistory[scrollHistory.lastObjectID] || 0;
      }

      if (scrollTo < 0) {
        scrollTo = 0;
      }

      console.log('Scroll State: scrolling to ' + scrollTo);

      var scrollTimeout = null;

      var scrollOnLoad = function scrollOnLoad() {
        clearTimeout(scrollTimeout);

        if (animate) {
          $('html, body').animate({ scrollTop: scrollTo }, 250);
        } else {
          $('html, body').scrollTop(scrollTo);
        }
      };

      scrollTimeout = setTimeout(scrollOnLoad, 250);
      $('body').one('htmlpress-loaded', scrollOnLoad);
    }

    function scrollNewPage() {
      // var contentStart = (($('#site-root .htmlpress-content-start').first().offset() || {}).top || 0);

      // console.log('Scroll State: content start: ' + contentStart + ', window height: ' + $(window).height());

      // doScroll(contentStart - $(window).height());

      doScroll(0);
    }

    function scrollNewContent() {
      var $found = findNewContent();

      if ($found.length < 1) {
        console.log('Scroll State: no new content found, not scrolling');
        return;
      }

      if ($(window).scrollTop() < $(window).height() / 2) {
        console.log('Scroll State: found new content, but nearly at top - not scrolling');
        return;
      }

      console.log('Scroll State: found new content', $found);

      var windowHeight = $(window).height();
      var withinHeight = windowHeight * 0.25;

      if (withinHeight > 150) {
        withinHeight = 150;
      }

      var windowOffsetTop = $(window).scrollTop();
      var elOffsetTop = ($found.offset() || {}).top || 0;
      var parentOffsetTop = ($found.parent().offset() || {}).top || 0;

      if (parentOffsetTop < elOffsetTop && Math.abs(elOffsetTop - parentOffsetTop) < withinHeight) {
        elOffsetTop = parentOffsetTop;
      }

      var diff = elOffsetTop - windowOffsetTop;

      // console.log(diff);

      if (Math.abs(diff) < withinHeight) {
        console.log('Scroll State: not scrolling, withinHeight > diff', withinHeight, Math.abs(diff));
        return;
      }

      if (diff > withinHeight) {
        diff -= withinHeight;
      } else if (diff < 0) {
        // diff = diff + withinHeight;
      }

      console.log('Scroll State: content section found, scrolling to', windowOffsetTop + diff);
      doScroll(windowOffsetTop + diff, true);
    }

    $('body').on('htmlpress-ready', function () {
      var currentObjectID = $('body').attr('data-object-id'),
          objectIDChanged = currentObjectID !== scrollHistory.lastObjectID;

      console.log('Last object-id: ' + scrollHistory.lastObjectID + ', currentObjectID: ' + currentObjectID);

      scrollHistory.lastObjectID = currentObjectID;

      if (!prevContent) {
        prevContent = getContentElements().map(function () {
          return sanitizeElementText($(this).text());
        }).toArray();

        return;
      }

      if (objectIDChanged) {
        console.log('Scroll State: object ID changed to ', currentObjectID);
        scrollNewPage();
      } else {
        scrollNewContent();
      }
    });

    $('body').on('htmlpress-loaded', function () {
      // force webflow scroll animation start
      var scrollTop = $(window).scrollTop();

      $('html, body').scrollTop(scrollTop + 1).scrollTop(scrollTop);
    });
  }, { "scroll-restoration-polyfill": 3 }], 16: [function (require, module, exports) {
    'use strict';

    $('body').on('htmlpress-ready', function () {
      $('#site-root').find('[data-is-sticky], .is-sticky').each(function () {
        if (!$(this).stickySidebar) {
          console.log('Sticky requested but no jQuery.stickySidebar seems to be loaded');
          return;
        }

        var settings = {
          containerSelector: 'body',
          stickyClass: 'w-focus',
          innerWrapperSelector: '.inner-wrapper-sticky'
        };

        [].filter.call(this.attributes, function (attr) {
          return (/^data-sticky/.test(attr.name)
          );
        }).forEach(function (attr) {
          var name = attr.name.replace(/^data-sticky-?/, '').replace(/-[a-z]/g, function (s) {
            return s.charAt(1).toUpperCase();
          }).trim();

          if (!name) {
            return;
          }

          var value = attr.value;

          settings[name] = value;
        });

        console.log('Init stickySidebar with settings ', settings);

        $(this).stickySidebar(settings);

        var children = $(this).find(settings.innerWrapperSelector + ' > *');
        console.log('children', children, settings.innerWrapperSelector + ' > *');

        this.addEventListener('affix.top.stickySidebar', function (e) {
          children.addClass(settings.stickyClass);
        });

        this.addEventListener('affix.bottom.stickySidebar', function (e) {
          children.addClass(settings.stickyClass);
        });

        this.addEventListener('affix.static.stickySidebar', function (e) {
          children.removeClass(settings.stickyClass);
        });
      });
    });
  }, {}], 17: [function (require, module, exports) {
    'use strict';

    var sectionSelector = '[id^="tab-"], [id$="-tab"]';

    $('body').on('htmlpress-ready', function () {
      var hash = (window.location.hash || '#').substr(1);

      $('#site-root').find(sectionSelector).addClass('htmlpress-tab').each(function () {
        var id = $(this).attr('id');

        if (id !== hash && $(this).prev(sectionSelector).length > 0) {
          $(this).addClass('htmlpress-tab-hidden');
          return;
        }

        $('#site-root').find("[href=\"#" + id + "\"]").trigger('click');

        if (($(this).parent().data('tabs-height') || 0) < this.scrollHeight) {
          $(this).parent().data('tabs-height', this.scrollHeight);
        }
      });

      $('#site-root [data-tabs-height]').each(function () {
        $(this).css('min-height', Math.min($(window).height(), $(this).data('tabs-height')) + 'px');
      });
    });

    $('#site-root').on('click', '[href^="#tab-"], [href^="#"][href$="-tab"]', function () {
      $(this).addClass('.w-focus');

      var $section = $('#site-root').find($(this).attr('href'));

      if ($section.length < 1) {
        console.log('No tab section found for ' + $(this).attr('href'));
        return;
      }

      $section.parent().css('min-height', $section[0].scrollHeight + 'px');

      $section.removeClass('htmlpress-tab-hidden');

      $section.prevAll('.htmlpress-tab').add($section.nextAll('.htmlpress-tab')).addClass('htmlpress-tab-hidden').each(function () {
        var id = $(this).attr('id');

        $('#site-root').find("[href=\"#" + id + "\"]").removeClass('.w-focus');
      });
    });
  }, {}], 18: [function (require, module, exports) {
    'use strict';

    function findToggleElements(el) {
      var selector = $(el).data('toggle-target'),
          elements;

      if (selector.charAt(0) === '>') {
        elements = $(el).find(selector.substr(1));
      } else {
        elements = $(selector);
      }

      if (!elements || elements.length < 1) {
        console.log('Data-toggle: No elements found to toggle for selector ' + JSON.stringify(selector));
      }

      // console.log("Data-toggle: Listening for " + $(el).data('toggle-event') + " on ", elements );

      return elements;
    }

    $(document).on('mh-update', '[data-mh]', function () {
      $.fn.matchHeight._update();
    });

    function doToggleTrigger(el) {
      var trigger = $(el).data('toggle-trigger');

      if (!trigger) {
        return;
      }

      $(el).trigger(trigger);
    }

    $(document).on('click', '[data-toggle-event="click"], [data-toggle-target]:not([data-toggle-event])', function () {
      doToggleTrigger(findToggleElements(this).toggleClass($(this).data('toggle-class')));
    });

    $('body').on('htmlpress-ready', function () {
      $('#site-root').find('[data-toggle-event="hover"]:not([toggle-init])').each(function () {
        var self = this;

        $(self).data('toggle-init', 'true');

        $(self).mouseenter(function () {
          doToggleTrigger(findToggleElements(self).addClass($(self).data('toggle-class')));
        });

        $(self).mouseleave(function () {
          findToggleElements(self).removeClass($(self).data('toggle-class'));
        });
      });

      $('#site-root').find('.w-tab-link:first-child').addClass('w--current').trigger('click');
    });
  }, {}], 19: [function (require, module, exports) {
    'use strict';

    var scrollBlockTimeout = null;

    function toggleScrollBlock() {
      var self = this;

      clearTimeout(scrollBlockTimeout);

      var $parentNav = $(self);

      if (!$parentNav.is('.w-nav')) {
        $parentNav = $parentNav.parents('.w-nav').first();
      }

      scrollBlockTimeout = setTimeout(function () {
        $('html, body').css({
          'overflow-y': $parentNav.find('.w--nav-menu-open, .w--open').length > 0 ? 'hidden' : 'auto'
        });
      }, ($parentNav.data('duration') || 0) + 25);
    }

    // $(window).on('resize', toggleScrollBlock);
    $(document.body).on('htmlpress-loaded', function () {
      $('html, body').css({
        'overflow-y': 'auto'
      });
    });

    $(document.body).on('click', '[data-doc-height="1"] .w-nav-button, [data-doc-height="1"] .w-nav-menu, [data-doc-height="1"]', toggleScrollBlock);
  }, {}] }, {}, [9]);